import { authorizedFetch } from 'services/auth';

const fetchBlob = async (link: string): Promise<Blob> => {
  const response = await authorizedFetch(link);
  if (!response.ok) throw new Error(`Download failed with status ${response.status}`);
  return response.blob();
};

export const downloadFile = async (link: string, fileName: string) => {
  let success = true;

  try {
    const data = await fetchBlob(link);

    const href = URL.createObjectURL(data);
    const linkElement = document.createElement('a');

    linkElement.href = href;
    linkElement.setAttribute('download', fileName);

    document.body.appendChild(linkElement);
    linkElement.click();

    document.body.removeChild(linkElement);
    URL.revokeObjectURL(href);
  } catch (error) {
    // Includes DegradedSessionError and refresh failures: non-auth failure, no session clear, no loop.
    success = false;
  }

  return success;
};
